import {Component} from "../../../gvf/js/component";

export class ModalForm extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    setForm($form){
        this.findMember("body").html($form);
    }

    setTitle(title){
        this.findMember("title").html(title);
    }

    ready(){
        super.ready();
        this.findMember("confirm").click(
            (ev)=>{
                this.$root.find(".js-form").submit();
            }
        );
    }
}

